import React from 'react'

const ApproveProjects = ({ title, value, projects = "" }: any) => {
    return (
        <div className='c-approve-projects-content'>
            <div className='c-approve-projects-pending-title'>
                <p>{projects} {title}</p>
            </div>
            <div className='approve-projects-pending-value'>
                <p>{value} MM</p>
            </div>
        </div>
    )
}

export default ApproveProjects